import { CoachInfoSubcomponentProps } from "../CoachInfo";

export default function About({ coachInfoData }: CoachInfoSubcomponentProps) {
    const bulletPoints: string[] = [];

    if (coachInfoData?.coach.description.includes("\n")) {
        bulletPoints.push(
            ...(coachInfoData?.coach.description
                .split("\n")
                .filter((sentence) => sentence.trim()) ?? []),
        );
    } else if (coachInfoData?.coach.description) {
        bulletPoints.push(coachInfoData?.coach.description);
    }

    if (
        // Only add ICF member info if ICF is not already mentioned in the description
        !coachInfoData?.coach.description?.toLowerCase().includes("icf") &&
        coachInfoData?.coach.matching_profile?.is_icf_member &&
        coachInfoData?.coach.matching_profile?.icf_member_year
    ) {
        bulletPoints.push(
            `ICF member since ${coachInfoData.coach.matching_profile.icf_member_year}`,
        );
    }

    coachInfoData?.coach.professional_positions
        .slice()
        .sort((a, b) => a.order - b.order)
        .slice(0, 3)
        .forEach((position) => {
            bulletPoints.push(
                `${position.years_at_role} years of experience as a ${position.job_title} in ${position.industry.pretty_name}`,
            );
        });

    return !coachInfoData ? (
        <AboutSkeleton />
    ) : (
        bulletPoints.length > 0 && (
            <div>
                <div className="font-bold text-xl">About</div>
                <ul>
                    {bulletPoints.map((sentence, i) => (
                        <li key={i} className="ml-8 list-disc text-brand-gray">
                            {sentence}
                        </li>
                    ))}
                </ul>
            </div>
        )
    );
}

function AboutSkeleton() {
    return (
        <div className="text-brand-gray animate-pulse">
            <div className="font-bold text-xl">About</div>
            <ul>
                {Array.from({ length: 4 }).map((_, i) => (
                    <li key={i} className="ml-8 list-disc">
                        <div
                            className="my-1 rounded-sm bg-brand-lightGray text-brand-lightGray animate-pulse"
                            style={{
                                // Pseudo random width between 60 and 200. Uses prime numbers to avoid patterns.
                                width: ((i * 5087 + 37) % 140) + 60,
                            }}
                        >
                            {"."}
                        </div>
                    </li>
                ))}
            </ul>
        </div>
    );
}
